import * as classnames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import Image from '../../atoms/Image/Image'
import TextLabel, { ColorType, SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'

import * as styles from './QuestionChoiceImage.css'

interface QuestionChoiceImageProps {
  label: string
  children: string
  src: string
  answerCount?: number
  totalAnswerCount?: number
  white: boolean
}

const QuestionChoiceImage: React.FunctionComponent<QuestionChoiceImageProps> = ({
  label,
  src,
  children,
  answerCount,
  totalAnswerCount,
  white
}) => (
  <div className={styles.button}>
    <div className={white ? classnames(styles.label, styles.blue) : styles.label}>{label}</div>
    <div className={styles.image}>
      <Image src={src} isContain={true} />
      {answerCount !== undefined && totalAnswerCount !== undefined ? (
        <div className={styles.answerCount}>
          <TextLabel color={ColorType.WHITE} size={SizeType.TINY}>
            {answerCount}
            <span className={styles.total}>/{totalAnswerCount}人</span>
          </TextLabel>
        </div>
      ) : null}
    </div>
    <div className={styles.text}>
      <TextLabel size={SizeType.SMALL} weight={WeightType.NORMAL} color={white ? ColorType.WHITE : ColorType.BASE}>
        {children}
      </TextLabel>
    </div>
  </div>
)

export default compose<QuestionChoiceImageProps, QuestionChoiceImageProps>(pure)(QuestionChoiceImage)
